export const isQrCodeTTLExpired = (ttl: number): boolean => {
  const curMillis = new Date().valueOf();
  return curMillis > ttl;
};
